module.exports = __webpack_public_path__ + "static/media/home-company-bg_lg.70a0cc40.jpg";